import { bairros } from "json/BairrosAju.json"

const ZONA =
{
    ZAP1: "ZAP1",
    ZAP2: "ZAP2",
    ZAP3: "ZAP3",
    ZAP4: "ZAP4",
    ZAP5: "ZAP5",
    ZAB1: "ZAB1",
    ZAB2: "ZAB2",
    ZAR: "ZAR"
}

const BAIRRO =
{
    DEZESSETE_DE_MARCO: "17 de Março",
    AEROPORTO: "Aeroporto",
    AMERICA: "América",
    AREIA_BRANCA: "Areia Branca",
    ARUANA: "Aruana",
    ATALAIA: "Atalaia",
    BUGIO: "Bugio",
    CAPUCHO: "Capucho",
    CENTRO: "Centro",
    CIDADE_NOVA: "Cidade Nova",
    CIRURGIA: "Cirurgia",
    COROA_DO_MEIO: "Coroa do Meio",
    DEZOITO_DO_FORTE: "Dezoito do Forte",
    DOM_LUCIANO: "Dom Luciano",
    FAROLANDIA: "Farolândia",
    GAMELEIRA: "Gameleira",
    GETULIO_VARGAS: "Getúlio Vargas",
    GRAGERU: "Grageru",
    INACIO_BARBOSA: "Inácio Barbosa",
    INDUSTRIAL: "Industrial",
    JABOTIANA: "Jabotiana",
    JAPAOZINHO: "Japãozinho",
    JARDIM_CENTENARIO: "Jardim Centenário",
    JARDINS: "Jardins",
    JOSE_CONRADO: "José Conrado de Araújo",
    LAMARAO: "Lamarão",
    LUZIA: "Luzia",
    MARIVAN: "Marivan",
    MATAPUA: "Matapuã",
    MOSQUEIRO: "Mosqueiro",
    NOVO_PARAISO: "Novo Paraíso",
    OLARIA: "Olaria",
    PALESTINA: "Palestina",
    PEREIRA_LOBO: "Pereira Lobo",
    PONTO_NOVO: "Ponto Novo",
    PORTO_DANTAS: "Porto D'antas",
    ROBALO: "Robalo",
    SALGADO_FILHO: "Salgado Filho",
    SANTA_MARIA: "Santa Maria",
    SANTO_ANTONIO: "Santo Antônio",
    SANTOS_DUMONT: "Santos Dumont",
    SAO_CONRADO: "São Conrado",
    SAO_JOSE: "São José",
    SAO_JOSE_DOS_NAUFRAGOS: "São José dos Náufragos",
    SIQUEIRA_CAMPOS: "Siqueira Campos",
    SOLEDADE: "Soledade",
    SUICA: "Suíça",
    TREZE_DE_JULHO: "Treze de Julho"
}

export function ZonaDoBairro(bairro)
{
    switch(bairro)
    {
        case BAIRRO.PORTO_DANTAS:
        case BAIRRO.SANTO_ANTONIO:
        case BAIRRO.JAPAOZINHO:
        case BAIRRO.LAMARAO:
        case BAIRRO.CIDADE_NOVA:
        case BAIRRO.DOM_LUCIANO:
        case BAIRRO.SOLEDADE:
        case BAIRRO.BUGIO:
        case BAIRRO.JARDIM_CENTENARIO:
        case BAIRRO.SANTOS_DUMONT:
        case BAIRRO.PALESTINA:
        case BAIRRO.DEZOITO_DO_FORTE:
            return ZONA.ZAB1

        case BAIRRO.JOSE_CONRADO:
        case BAIRRO.CAPUCHO:
        case BAIRRO.NOVO_PARAISO:
        case BAIRRO.JABOTIANA:
        case BAIRRO.PONTO_NOVO:
        case BAIRRO.LUZIA:
        case BAIRRO.JARDINS:
        case BAIRRO.COROA_DO_MEIO:
        case BAIRRO.INACIO_BARBOSA:
        case BAIRRO.SAO_CONRADO:
        case BAIRRO.FAROLANDIA:
        case BAIRRO.AEROPORTO:
        case BAIRRO.ATALAIA:
            return ZONA.ZAB2

        case BAIRRO.ROBALO:
        case BAIRRO.SAO_JOSE_DOS_NAUFRAGOS:
        case BAIRRO.AREIA_BRANCA:
        case BAIRRO.GAMELEIRA:
        case BAIRRO.MATAPUA:
        case BAIRRO.MOSQUEIRO:
            return ZONA.ZAR

        case BAIRRO.SAO_JOSE:
            return ZONA.ZAP3

        case BAIRRO.SALGADO_FILHO:
            return ZONA.ZAP5

        default: return
    }
}